import { z } from "zod";

const PUSH_TOKEN_STORAGE_KEY_PREFIX = "pushNotificationToken_";
const TOKEN_REREGISTRATION_INTERVAL_MS = 24 * 60 * 60 * 1000; // 24 hours

interface StoredPushToken {
  token: string;
  timestamp: number;
}

const storedPushTokenSchema = z.object({
  token: z.string(),
  timestamp: z.number(),
});

export function getPushTokenStorageKey(userId: string): string {
  return `${PUSH_TOKEN_STORAGE_KEY_PREFIX}${userId}`;
}

export function getStoredPushToken(userId: string): StoredPushToken | undefined {
  try {
    const stored = localStorage.getItem(getPushTokenStorageKey(userId));
    if (!stored) {
      return undefined;
    }

    return storedPushTokenSchema.parse(JSON.parse(stored));
  } catch {
    return undefined;
  }
}

export function storePushToken(userId: string, token: string): void {
  const entry: StoredPushToken = { token, timestamp: Date.now() };
  localStorage.setItem(getPushTokenStorageKey(userId), JSON.stringify(entry));
}

export function removeStoredPushToken(userId: string): void {
  localStorage.removeItem(getPushTokenStorageKey(userId));
}

export function shouldSendPushToken(userId: string, token: string): boolean {
  const stored = getStoredPushToken(userId);
  if (!stored) {
    return true;
  }

  const tokenChanged = stored.token !== token; // eslint-disable-line security/detect-possible-timing-attacks
  if (tokenChanged) {
    return true;
  }

  return Date.now() - stored.timestamp > TOKEN_REREGISTRATION_INTERVAL_MS;
}
